import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './CompleteProfile.css';

const CompleteProfile = () => {
  const navigate = useNavigate();
  const { completeProfile } = useAuth();
  const submittingRef = useRef(false);
  const redirectTimerRef = useRef(null);

  useEffect(() => () => clearTimeout(redirectTimerRef.current), []);

  const location = useLocation();
  const { userData: navUserData, token: navToken } =
    location.state || {};

  let storedUser = null;

  try {
    storedUser =
      JSON.parse(localStorage.getItem('marilink_user')) || null;
  } catch (e) {
    storedUser = null;
  }

  const userData = navUserData || storedUser || {};
  const token =
    navToken || localStorage.getItem('marilink_token');

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const [formData, setFormData] = useState({
    role: userData?.role || 'owner',
    company: userData?.company || '',
    phone: userData?.phone || '',
    location: userData?.location || ''
  });

  const [spData, setSpData] = useState({
    phoneNumber: userData?.phone || '',
    countryCode: '+971',
    whatsappNumber: '',
    whatsappCode: '+971',
    useSameAsPhone: true,
    companyDescription: '',
    countries: [],
    services: [],
    ports: [],
    customService: '',
    customPort: ''
  });

  const [countryInput, setCountryInput] = useState('');
  const [showCountryDropdown, setShowCountryDropdown] =
    useState(false);
  const countryDropdownRef = useRef(null);

  const [serviceInput, setServiceInput] = useState('');
  const [showServiceDropdown, setShowServiceDropdown] =
    useState(false);
  const [showCustomServiceInput, setShowCustomServiceInput] =
    useState(false);
  const serviceDropdownRef = useRef(null);

  const [portInput, setPortInput] = useState('');
  const [showPortDropdown, setShowPortDropdown] = useState(false);
  const [showCustomPortInput, setShowCustomPortInput] =
    useState(false);
  const portDropdownRef = useRef(null);

  const [countryCodeInput, setCountryCodeInput] = useState('');
  const [showCountryCodeDropdown, setShowCountryCodeDropdown] =
    useState(false);
  const countryCodeRef = useRef(null);

  const [whatsappCodeInput, setWhatsappCodeInput] = useState('');
  const [showWhatsAppCodeDropdown, setShowWhatsAppCodeDropdown] =
    useState(false);
  const whatsappCodeRef = useRef(null);

  const countriesList = [
    { name: 'Afghanistan', flag: '🇦🇫' }, { name: 'Albania', flag: '🇦🇱' },
    { name: 'Algeria', flag: '🇩🇿' }, { name: 'Andorra', flag: '🇦🇩' },
    { name: 'Angola', flag: '🇦🇴' }, { name: 'Argentina', flag: '🇦🇷' },
    { name: 'Armenia', flag: '🇦🇲' }, { name: 'Australia', flag: '🇦🇺' },
    { name: 'Austria', flag: '🇦🇹' }, { name: 'Azerbaijan', flag: '🇦🇿' },
    { name: 'Bahamas', flag: '🇧🇸' }, { name: 'Bahrain', flag: '🇧🇭' },
    { name: 'Bangladesh', flag: '🇧🇩' }, { name: 'Barbados', flag: '🇧🇧' },
    { name: 'Belarus', flag: '🇧🇾' }, { name: 'Belgium', flag: '🇧🇪' },
    { name: 'Belize', flag: '🇧🇿' }, { name: 'Benin', flag: '🇧🇯' },
    { name: 'Bhutan', flag: '🇧🇹' }, { name: 'Bolivia', flag: '🇧🇴' },
    { name: 'Bosnia and Herzegovina', flag: '🇧🇦' }, { name: 'Botswana', flag: '🇧🇼' },
    { name: 'Brazil', flag: '🇧🇷' }, { name: 'Brunei', flag: '🇧🇳' },
    { name: 'Bulgaria', flag: '🇧🇬' }, { name: 'Burkina Faso', flag: '🇧🇫' },
    { name: 'Burundi', flag: '🇧🇮' }, { name: 'Cambodia', flag: '🇰🇭' },
    { name: 'Cameroon', flag: '🇨🇲' }, { name: 'Canada', flag: '🇨🇦' },
    { name: 'Chad', flag: '🇹🇩' }, { name: 'Chile', flag: '🇨🇱' },
    { name: 'China', flag: '🇨🇳' }, { name: 'Colombia', flag: '🇨🇴' },
    { name: 'Comoros', flag: '🇰🇲' }, { name: 'Congo', flag: '🇨🇬' },
    { name: 'Costa Rica', flag: '🇨🇷' }, { name: 'Croatia', flag: '🇭🇷' },
    { name: 'Cuba', flag: '🇨🇺' }, { name: 'Cyprus', flag: '🇨🇾' },
    { name: 'Czech Republic', flag: '🇨🇿' }, { name: 'Denmark', flag: '🇩🇰' },
    { name: 'Djibouti', flag: '🇩🇯' }, { name: 'Dominica', flag: '🇩🇲' },
    { name: 'Dominican Republic', flag: '🇩🇴' }, { name: 'Ecuador', flag: '🇪🇨' },
    { name: 'Egypt', flag: '🇪🇬' }, { name: 'El Salvador', flag: '🇸🇻' },
    { name: 'Equatorial Guinea', flag: '🇬🇶' }, { name: 'Eritrea', flag: '🇪🇷' },
    { name: 'Estonia', flag: '🇪🇪' }, { name: 'Eswatini', flag: '🇸🇿' },
    { name: 'Ethiopia', flag: '🇪🇹' }, { name: 'Fiji', flag: '🇫🇯' },
    { name: 'Finland', flag: '🇫🇮' }, { name: 'France', flag: '🇫🇷' },
    { name: 'Gabon', flag: '🇬🇦' }, { name: 'Gambia', flag: '🇬🇲' },
    { name: 'Georgia', flag: '🇬🇪' }, { name: 'Germany', flag: '🇩🇪' },
    { name: 'Ghana', flag: '🇬🇭' }, { name: 'Greece', flag: '🇬🇷' },
    { name: 'Grenada', flag: '🇬🇩' }, { name: 'Guatemala', flag: '🇬🇹' },
    { name: 'Guinea', flag: '🇬🇳' }, { name: 'Guinea-Bissau', flag: '🇬🇼' },
    { name: 'Guyana', flag: '🇬🇾' }, { name: 'Haiti', flag: '🇭🇹' },
    { name: 'Honduras', flag: '🇭🇳' }, { name: 'Hungary', flag: '🇭🇺' },
    { name: 'Iceland', flag: '🇮🇸' }, { name: 'India', flag: '🇮🇳' },
    { name: 'Indonesia', flag: '🇮🇩' }, { name: 'Iran', flag: '🇮🇷' },
    { name: 'Iraq', flag: '🇮🇶' }, { name: 'Ireland', flag: '🇮🇪' },
    { name: 'Israel', flag: '🇮🇱' }, { name: 'Italy', flag: '🇮🇹' },
    { name: 'Jamaica', flag: '🇯🇲' }, { name: 'Japan', flag: '🇯🇵' },
    { name: 'Jordan', flag: '🇯🇴' }, { name: 'Kazakhstan', flag: '🇰🇿' },
    { name: 'Kenya', flag: '🇰🇪' }, { name: 'Kiribati', flag: '🇰🇮' },
    { name: 'Kuwait', flag: '🇰🇼' }, { name: 'Kyrgyzstan', flag: '🇰🇬' },
    { name: 'Laos', flag: '🇱🇦' }, { name: 'Latvia', flag: '🇱🇻' },
    { name: 'Lebanon', flag: '🇱🇧' }, { name: 'Lesotho', flag: '🇱🇸' },
    { name: 'Liberia', flag: '🇱🇷' }, { name: 'Libya', flag: '🇱🇾' },
    { name: 'Liechtenstein', flag: '🇱🇮' }, { name: 'Lithuania', flag: '🇱🇹' },
    { name: 'Luxembourg', flag: '🇱🇺' }, { name: 'Madagascar', flag: '🇲🇬' },
    { name: 'Malawi', flag: '🇲🇼' }, { name: 'Malaysia', flag: '🇲🇾' },
    { name: 'Maldives', flag: '🇲🇻' }, { name: 'Mali', flag: '🇲🇱' },
    { name: 'Malta', flag: '🇲🇹' }, { name: 'Marshall Islands', flag: '🇲🇭' },
    { name: 'Mauritania', flag: '🇲🇷' }, { name: 'Mauritius', flag: '🇲🇺' },
    { name: 'Mexico', flag: '🇲🇽' }, { name: 'Micronesia', flag: '🇫🇲' },
    { name: 'Moldova', flag: '🇲🇩' }, { name: 'Monaco', flag: '🇲🇨' },
    { name: 'Mongolia', flag: '🇲🇳' }, { name: 'Montenegro', flag: '🇲🇪' },
    { name: 'Morocco', flag: '🇲🇦' }, { name: 'Mozambique', flag: '🇲🇿' },
    { name: 'Myanmar', flag: '🇲🇲' }, { name: 'Namibia', flag: '🇳🇦' },
    { name: 'Nauru', flag: '🇳🇷' }, { name: 'Nepal', flag: '🇳🇵' },
    { name: 'Netherlands', flag: '🇳🇱' }, { name: 'New Zealand', flag: '🇳🇿' },
    { name: 'Nicaragua', flag: '🇳🇮' }, { name: 'Niger', flag: '🇳🇪' },
    { name: 'Nigeria', flag: '🇳🇬' }, { name: 'North Korea', flag: '🇰🇵' },
    { name: 'North Macedonia', flag: '🇲🇰' }, { name: 'Norway', flag: '🇳🇴' },
    { name: 'Oman', flag: '🇴🇲' }, { name: 'Pakistan', flag: '🇵🇰' },
    { name: 'Palau', flag: '🇵🇼' }, { name: 'Panama', flag: '🇵🇦' },
    { name: 'Papua New Guinea', flag: '🇵🇬' }, { name: 'Paraguay', flag: '🇵🇾' },
    { name: 'Peru', flag: '🇵🇪' }, { name: 'Philippines', flag: '🇵🇭' },
    { name: 'Poland', flag: '🇵🇱' }, { name: 'Portugal', flag: '🇵🇹' },
    { name: 'Qatar', flag: '🇶🇦' }, { name: 'Romania', flag: '🇷🇴' },
    { name: 'Russia', flag: '🇷🇺' }, { name: 'Rwanda', flag: '🇷🇼' },
    { name: 'Saint Kitts and Nevis', flag: '🇰🇳' }, { name: 'Saint Lucia', flag: '🇱🇨' },
    { name: 'Saint Vincent and the Grenadines', flag: '🇻🇨' }, { name: 'Samoa', flag: '🇼🇸' },
    { name: 'San Marino', flag: '🇸🇲' }, { name: 'Sao Tome and Principe', flag: '🇸🇹' },
    { name: 'Saudi Arabia', flag: '🇸🇦' }, { name: 'Senegal', flag: '🇸🇳' },
    { name: 'Serbia', flag: '🇷🇸' }, { name: 'Seychelles', flag: '🇸🇨' },
    { name: 'Sierra Leone', flag: '🇸🇱' }, { name: 'Singapore', flag: '🇸🇬' },
    { name: 'Slovakia', flag: '🇸🇰' }, { name: 'Slovenia', flag: '🇸🇮' },
    { name: 'Solomon Islands', flag: '🇸🇧' }, { name: 'Somalia', flag: '🇸🇴' },
    { name: 'South Africa', flag: '🇿🇦' }, { name: 'South Korea', flag: '🇰🇷' },
    { name: 'South Sudan', flag: '🇸🇸' }, { name: 'Spain', flag: '🇪🇸' },
    { name: 'Sri Lanka', flag: '🇱🇰' }, { name: 'Sudan', flag: '🇸🇩' },
    { name: 'Suriname', flag: '🇸🇷' }, { name: 'Sweden', flag: '🇸🇪' },
    { name: 'Switzerland', flag: '🇨🇭' }, { name: 'Syria', flag: '🇸🇾' },
    { name: 'Taiwan', flag: '🇹🇼' }, { name: 'Tajikistan', flag: '🇹🇯' },
    { name: 'Tanzania', flag: '🇹🇿' }, { name: 'Thailand', flag: '🇹🇭' },
    { name: 'Timor-Leste', flag: '🇹🇱' }, { name: 'Togo', flag: '🇹🇬' },
    { name: 'Tonga', flag: '🇹🇴' }, { name: 'Trinidad and Tobago', flag: '🇹🇹' },
    { name: 'Tunisia', flag: '🇹🇳' }, { name: 'Turkey', flag: '🇹🇷' },
    { name: 'Turkmenistan', flag: '🇹🇲' }, { name: 'Tuvalu', flag: '🇹🇻' },
    { name: 'Uganda', flag: '🇺🇬' }, { name: 'Ukraine', flag: '🇺🇦' },
    { name: 'United Arab Emirates', flag: '🇦🇪' }, { name: 'United Kingdom', flag: '🇬🇧' },
    { name: 'United States', flag: '🇺🇸' }, { name: 'Uruguay', flag: '🇺🇾' },
    { name: 'Uzbekistan', flag: '🇺🇿' }, { name: 'Vanuatu', flag: '🇻🇺' },
    { name: 'Vatican City', flag: '🇻🇦' }, { name: 'Venezuela', flag: '🇻🇪' },
    { name: 'Vietnam', flag: '🇻🇳' }, { name: 'Yemen', flag: '🇾🇪' },
    { name: 'Zambia', flag: '🇿🇲' }, { name: 'Zimbabwe', flag: '🇿🇼' }
  ];

  const countryCodesList = [
    { code: '+93', country: 'Afghanistan', flag: '🇦🇫' }, { code: '+355', country: 'Albania', flag: '🇦🇱' },
    { code: '+213', country: 'Algeria', flag: '🇩🇿' }, { code: '+376', country: 'Andorra', flag: '🇦🇩' },
    { code: '+244', country: 'Angola', flag: '🇦🇴' }, { code: '+54', country: 'Argentina', flag: '🇦🇷' },
    { code: '+374', country: 'Armenia', flag: '🇦🇲' }, { code: '+61', country: 'Australia', flag: '🇦🇺' },
    { code: '+43', country: 'Austria', flag: '🇦🇹' }, { code: '+994', country: 'Azerbaijan', flag: '🇦🇿' },
    { code: '+1242', country: 'Bahamas', flag: '🇧🇸' }, { code: '+973', country: 'Bahrain', flag: '🇧🇭' },
    { code: '+880', country: 'Bangladesh', flag: '🇧🇩' }, { code: '+1246', country: 'Barbados', flag: '🇧🇧' },
    { code: '+375', country: 'Belarus', flag: '🇧🇾' }, { code: '+32', country: 'Belgium', flag: '🇧🇪' },
    { code: '+501', country: 'Belize', flag: '🇧🇿' }, { code: '+229', country: 'Benin', flag: '🇧🇯' },
    { code: '+975', country: 'Bhutan', flag: '🇧🇹' }, { code: '+591', country: 'Bolivia', flag: '🇧🇴' },
    { code: '+387', country: 'Bosnia and Herzegovina', flag: '🇧🇦' }, { code: '+267', country: 'Botswana', flag: '🇧🇼' },
    { code: '+55', country: 'Brazil', flag: '🇧🇷' }, { code: '+673', country: 'Brunei', flag: '🇧🇳' },
    { code: '+359', country: 'Bulgaria', flag: '🇧🇬' }, { code: '+226', country: 'Burkina Faso', flag: '🇧🇫' },
    { code: '+257', country: 'Burundi', flag: '🇧🇮' }, { code: '+855', country: 'Cambodia', flag: '🇰🇭' },
    { code: '+237', country: 'Cameroon', flag: '🇨🇲' }, { code: '+1', country: 'Canada', flag: '🇨🇦' },
    { code: '+236', country: 'Central African Republic', flag: '🇨🇫' }, { code: '+235', country: 'Chad', flag: '🇹🇩' },
    { code: '+56', country: 'Chile', flag: '🇨🇱' }, { code: '+86', country: 'China', flag: '🇨🇳' },
    { code: '+57', country: 'Colombia', flag: '🇨🇴' }, { code: '+269', country: 'Comoros', flag: '🇰🇲' },
    { code: '+242', country: 'Congo', flag: '🇨🇬' }, { code: '+506', country: 'Costa Rica', flag: '🇨🇷' },
    { code: '+385', country: 'Croatia', flag: '🇭🇷' }, { code: '+53', country: 'Cuba', flag: '🇨🇺' },
    { code: '+357', country: 'Cyprus', flag: '🇨🇾' }, { code: '+420', country: 'Czech Republic', flag: '🇨🇿' },
    { code: '+45', country: 'Denmark', flag: '🇩🇰' }, { code: '+253', country: 'Djibouti', flag: '🇩🇯' },
    { code: '+1767', country: 'Dominica', flag: '🇩🇲' }, { code: '+1849', country: 'Dominican Republic', flag: '🇩🇴' },
    { code: '+593', country: 'Ecuador', flag: '🇪🇨' }, { code: '+20', country: 'Egypt', flag: '🇪🇬' },
    { code: '+503', country: 'El Salvador', flag: '🇸🇻' }, { code: '+240', country: 'Equatorial Guinea', flag: '🇬🇶' },
    { code: '+291', country: 'Eritrea', flag: '🇪🇷' }, { code: '+372', country: 'Estonia', flag: '🇪🇪' },
    { code: '+251', country: 'Ethiopia', flag: '🇪🇹' }, { code: '+679', country: 'Fiji', flag: '🇫🇯' },
    { code: '+358', country: 'Finland', flag: '🇫🇮' }, { code: '+33', country: 'France', flag: '🇫🇷' },
    { code: '+241', country: 'Gabon', flag: '🇬🇦' }, { code: '+220', country: 'Gambia', flag: '🇬🇲' },
    { code: '+995', country: 'Georgia', flag: '🇬🇪' }, { code: '+49', country: 'Germany', flag: '🇩🇪' },
    { code: '+233', country: 'Ghana', flag: '🇬🇭' }, { code: '+30', country: 'Greece', flag: '🇬🇷' },
    { code: '+1473', country: 'Grenada', flag: '🇬🇩' }, { code: '+502', country: 'Guatemala', flag: '🇬🇹' },
    { code: '+224', country: 'Guinea', flag: '🇬🇳' }, { code: '+245', country: 'Guinea-Bissau', flag: '🇬🇼' },
    { code: '+592', country: 'Guyana', flag: '🇬🇾' }, { code: '+509', country: 'Haiti', flag: '🇭🇹' },
    { code: '+504', country: 'Honduras', flag: '🇭🇳' }, { code: '+36', country: 'Hungary', flag: '🇭🇺' },
    { code: '+354', country: 'Iceland', flag: '🇮🇸' }, { code: '+91', country: 'India', flag: '🇮🇳' },
    { code: '+62', country: 'Indonesia', flag: '🇮🇩' }, { code: '+98', country: 'Iran', flag: '🇮🇷' },
    { code: '+964', country: 'Iraq', flag: '🇮🇶' }, { code: '+353', country: 'Ireland', flag: '🇮🇪' },
    { code: '+972', country: 'Israel', flag: '🇮🇱' }, { code: '+39', country: 'Italy', flag: '🇮🇹' },
    { code: '+1876', country: 'Jamaica', flag: '🇯🇲' }, { code: '+81', country: 'Japan', flag: '🇯🇵' },
    { code: '+962', country: 'Jordan', flag: '🇯🇴' }, { code: '+7', country: 'Kazakhstan', flag: '🇰🇿' },
    { code: '+254', country: 'Kenya', flag: '🇰🇪' }, { code: '+686', country: 'Kiribati', flag: '🇰🇮' },
    { code: '+965', country: 'Kuwait', flag: '🇰🇼' }, { code: '+996', country: 'Kyrgyzstan', flag: '🇰🇬' },
    { code: '+856', country: 'Laos', flag: '🇱🇦' }, { code: '+371', country: 'Latvia', flag: '🇱🇻' },
    { code: '+961', country: 'Lebanon', flag: '🇱🇧' }, { code: '+266', country: 'Lesotho', flag: '🇱🇸' },
    { code: '+231', country: 'Liberia', flag: '🇱🇷' }, { code: '+218', country: 'Libya', flag: '🇱🇾' },
    { code: '+423', country: 'Liechtenstein', flag: '🇱🇮' }, { code: '+370', country: 'Lithuania', flag: '🇱🇹' },
    { code: '+352', country: 'Luxembourg', flag: '🇱🇺' }, { code: '+261', country: 'Madagascar', flag: '🇲🇬' },
    { code: '+265', country: 'Malawi', flag: '🇲🇼' }, { code: '+60', country: 'Malaysia', flag: '🇲🇾' },
    { code: '+960', country: 'Maldives', flag: '🇲🇻' }, { code: '+223', country: 'Mali', flag: '🇲🇱' },
    { code: '+356', country: 'Malta', flag: '🇲🇹' }, { code: '+692', country: 'Marshall Islands', flag: '🇲🇭' },
    { code: '+222', country: 'Mauritania', flag: '🇲🇷' }, { code: '+230', country: 'Mauritius', flag: '🇲🇺' },
    { code: '+52', country: 'Mexico', flag: '🇲🇽' }, { code: '+691', country: 'Micronesia', flag: '🇫🇲' },
    { code: '+373', country: 'Moldova', flag: '🇲🇩' }, { code: '+377', country: 'Monaco', flag: '🇲🇨' },
    { code: '+976', country: 'Mongolia', flag: '🇲🇳' }, { code: '+382', country: 'Montenegro', flag: '🇲🇪' },
    { code: '+212', country: 'Morocco', flag: '🇲🇦' }, { code: '+258', country: 'Mozambique', flag: '🇲🇿' },
    { code: '+95', country: 'Myanmar', flag: '🇲🇲' }, { code: '+264', country: 'Namibia', flag: '🇳🇦' },
    { code: '+674', country: 'Nauru', flag: '🇳🇷' }, { code: '+977', country: 'Nepal', flag: '🇳🇵' },
    { code: '+31', country: 'Netherlands', flag: '🇳🇱' }, { code: '+64', country: 'New Zealand', flag: '🇳🇿' },
    { code: '+505', country: 'Nicaragua', flag: '🇳🇮' }, { code: '+227', country: 'Niger', flag: '🇳🇪' },
    { code: '+234', country: 'Nigeria', flag: '🇳🇬' }, { code: '+850', country: 'North Korea', flag: '🇰🇵' },
    { code: '+389', country: 'North Macedonia', flag: '🇲🇰' }, { code: '+47', country: 'Norway', flag: '🇳🇴' },
    { code: '+968', country: 'Oman', flag: '🇴🇲' }, { code: '+92', country: 'Pakistan', flag: '🇵🇰' },
    { code: '+680', country: 'Palau', flag: '🇵🇼' }, { code: '+507', country: 'Panama', flag: '🇵🇦' },
    { code: '+675', country: 'Papua New Guinea', flag: '🇵🇬' }, { code: '+595', country: 'Paraguay', flag: '🇵🇾' },
    { code: '+51', country: 'Peru', flag: '🇵🇪' }, { code: '+63', country: 'Philippines', flag: '🇵🇭' },
    { code: '+48', country: 'Poland', flag: '🇵🇱' }, { code: '+351', country: 'Portugal', flag: '🇵🇹' },
    { code: '+974', country: 'Qatar', flag: '🇶🇦' }, { code: '+40', country: 'Romania', flag: '🇷🇴' },
    { code: '+7', country: 'Russia', flag: '🇷🇺' }, { code: '+250', country: 'Rwanda', flag: '🇷🇼' },
    { code: '+1869', country: 'Saint Kitts and Nevis', flag: '🇰🇳' }, { code: '+1758', country: 'Saint Lucia', flag: '🇱🇨' },
    { code: '+1784', country: 'Saint Vincent and the Grenadines', flag: '🇻🇨' }, { code: '+685', country: 'Samoa', flag: '🇼🇸' },
    { code: '+378', country: 'San Marino', flag: '🇸🇲' }, { code: '+239', country: 'Sao Tome and Principe', flag: '🇸🇹' },
    { code: '+966', country: 'Saudi Arabia', flag: '🇸🇦' }, { code: '+221', country: 'Senegal', flag: '🇸🇳' },
    { code: '+381', country: 'Serbia', flag: '🇷🇸' }, { code: '+248', country: 'Seychelles', flag: '🇸🇨' },
    { code: '+232', country: 'Sierra Leone', flag: '🇸🇱' }, { code: '+65', country: 'Singapore', flag: '🇸🇬' },
    { code: '+421', country: 'Slovakia', flag: '🇸🇰' }, { code: '+386', country: 'Slovenia', flag: '🇸🇮' },
    { code: '+677', country: 'Solomon Islands', flag: '🇸🇧' }, { code: '+252', country: 'Somalia', flag: '🇸🇴' },
    { code: '+27', country: 'South Africa', flag: '🇿🇦' }, { code: '+82', country: 'South Korea', flag: '🇰🇷' },
    { code: '+211', country: 'South Sudan', flag: '🇸🇸' }, { code: '+34', country: 'Spain', flag: '🇪🇸' },
    { code: '+94', country: 'Sri Lanka', flag: '🇱🇰' }, { code: '+249', country: 'Sudan', flag: '🇸🇩' },
    { code: '+597', country: 'Suriname', flag: '🇸🇷' }, { code: '+46', country: 'Sweden', flag: '🇸🇪' },
    { code: '+41', country: 'Switzerland', flag: '🇨🇭' }, { code: '+963', country: 'Syria', flag: '🇸🇾' },
    { code: '+886', country: 'Taiwan', flag: '🇹🇼' }, { code: '+992', country: 'Tajikistan', flag: '🇹🇯' },
    { code: '+255', country: 'Tanzania', flag: '🇹🇿' }, { code: '+66', country: 'Thailand', flag: '🇹🇭' },
    { code: '+670', country: 'Timor-Leste', flag: '🇹🇱' }, { code: '+228', country: 'Togo', flag: '🇹🇬' },
    { code: '+676', country: 'Tonga', flag: '🇹🇴' }, { code: '+1868', country: 'Trinidad and Tobago', flag: '🇹🇹' },
    { code: '+216', country: 'Tunisia', flag: '🇹🇳' }, { code: '+90', country: 'Turkey', flag: '🇹🇷' },
    { code: '+993', country: 'Turkmenistan', flag: '🇹🇲' }, { code: '+688', country: 'Tuvalu', flag: '🇹🇻' },
    { code: '+256', country: 'Uganda', flag: '🇺🇬' }, { code: '+380', country: 'Ukraine', flag: '🇺🇦' },
    { code: '+971', country: 'United Arab Emirates', flag: '🇦🇪' }, { code: '+44', country: 'United Kingdom', flag: '🇬🇧' },
    { code: '+1', country: 'United States', flag: '🇺🇸' }, { code: '+598', country: 'Uruguay', flag: '🇺🇾' },
    { code: '+998', country: 'Uzbekistan', flag: '🇺🇿' }, { code: '+678', country: 'Vanuatu', flag: '🇻🇺' },
    { code: '+379', country: 'Vatican City', flag: '🇻🇦' }, { code: '+58', country: 'Venezuela', flag: '🇻🇪' },
    { code: '+84', country: 'Vietnam', flag: '🇻🇳' }, { code: '+967', country: 'Yemen', flag: '🇾🇪' },
    { code: '+260', country: 'Zambia', flag: '🇿🇲' }, { code: '+263', country: 'Zimbabwe', flag: '🇿🇼' }
  ];

  const serviceCategoriesList = [
    'GMDSS Annual Survey', 'GMDSS Repair', 'Radio Survey', 'SBM Maintenance',
    'Battery Replacement', 'Gyro Compass Repair', 'Radar Calibration',
    'AIS Service', 'ECDIS Service', 'EPIRB Testing', 'SART Testing',
    'NAVTEX Service', 'Safety Equipment Inspection', 'Navigation Systems',
    'Technical Spares Supply', 'VSAT & Communication', 'Crane & Winch Service',
    'HVAC & Refrigeration', 'Electrical Engineering', 'Main Engine Overhaul',
    'Hydraulic Systems', 'Ballast Water Systems', 'Tank Cleaning',
    'Lifeboat & Davit Service', 'Fire Fighting Equipment', 'Pest Control',
    'Crew Change Coordination', 'Customs Brokerage', 'Port Agency Services',
    'Ship Chandling', 'Bunkering Coordination', 'Marine Lubricants',
    'Hull Cleaning & Diving', 'Propeller Polishing', 'Underwater Inspection',
    'Medical & Healthcare', 'Lube Oil Analysis', 'Logistics & Storage',
    'Others'
  ];

  const portsList = [
    'Dubai, UAE', 'Abu Dhabi, UAE', 'Sharjah, UAE', 'Fujairah, UAE',
    'Jebel Ali, UAE', 'Khor Fakkan, UAE', 'Ras Al Khaimah, UAE',
    'Jeddah, Saudi Arabia', 'Dammam, Saudi Arabia', 'Yanbu, Saudi Arabia',
    'Doha, Qatar', 'Ras Laffan, Qatar', 'Manama, Bahrain', 'Sitra, Bahrain',
    'Muscat, Oman', 'Salalah, Oman', 'Sohar, Oman', 'Duqm, Oman',
    'Kuwait City, Kuwait', 'Shuwaikh, Kuwait',
    'Singapore', 'Hong Kong', 'Shanghai, China', 'Busan, South Korea',
    'Tokyo, Japan', 'Yokohama, Japan', 'Kaohsiung, Taiwan',
    'Jakarta, Indonesia', 'Port Klang, Malaysia', 'Bangkok, Thailand',
    'Ho Chi Minh City, Vietnam', 'Manila, Philippines',
    'Colombo, Sri Lanka', 'Chittagong, Bangladesh',
    'Mumbai, India', 'Chennai, India', 'Kolkata, India',
    'Karachi, Pakistan', 'Gwadar, Pakistan',
    'Lagos, Nigeria', 'Tema, Ghana', 'Abidjan, Ivory Coast',
    'Dakar, Senegal', 'Mombasa, Kenya', 'Dar es Salaam, Tanzania',
    'Durban, South Africa', 'Cape Town, South Africa',
    'Alexandria, Egypt', 'Port Said, Egypt', 'Suez, Egypt',
    'Casablanca, Morocco', 'Tunis, Tunisia', 'Algiers, Algeria',
    'Rotterdam, Netherlands', 'Antwerp, Belgium', 'Hamburg, Germany',
    'London, UK', 'Southampton, UK', 'Liverpool, UK',
    'Marseille, France', 'Barcelona, Spain', 'Valencia, Spain',
    'Genoa, Italy', 'Piraeus, Greece', 'Istanbul, Turkey',
    'Constanta, Romania', 'Odessa, Ukraine',
    'Houston, USA', 'New York, USA', 'Los Angeles, USA',
    'Miami, USA', 'New Orleans, USA', 'Vancouver, Canada',
    'Santos, Brazil', 'Buenos Aires, Argentina',
    'Panama Canal, Panama', 'Kingston, Jamaica',
    'Others'
  ];

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        countryDropdownRef.current &&
        !countryDropdownRef.current.contains(e.target)
      ) {
        setShowCountryDropdown(false);
      }

      if (
        serviceDropdownRef.current &&
        !serviceDropdownRef.current.contains(e.target)
      ) {
        setShowServiceDropdown(false);
      }

      if (
        countryCodeRef.current &&
        !countryCodeRef.current.contains(e.target)
      ) {
        setShowCountryCodeDropdown(false);
      }

      if (
        whatsappCodeRef.current &&
        !whatsappCodeRef.current.contains(e.target)
      ) {
        setShowWhatsAppCodeDropdown(false);
      }

      if (
        portDropdownRef.current &&
        !portDropdownRef.current.contains(e.target)
      ) {
        setShowPortDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (spData.useSameAsPhone) {
      setSpData(prev => ({
        ...prev,
        whatsappNumber: prev.phoneNumber,
        whatsappCode: prev.countryCode
      }));
    }
  }, [
    spData.phoneNumber,
    spData.countryCode,
    spData.useSameAsPhone
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    if (error) {
      setError('');
    }
  };

  const handleSpChange = (e) => {
    setSpData({
      ...spData,
      [e.target.name]: e.target.value
    });
  };

  const handleUseSameAsPhone = (checked) => {
    if (checked) {
      setSpData(prev => ({
        ...prev,
        useSameAsPhone: true,
        whatsappNumber: prev.phoneNumber,
        whatsappCode: prev.countryCode
      }));
    } else {
      setSpData(prev => ({
        ...prev,
        useSameAsPhone: false
      }));
    }
  };

  const selectCountryCode = (code) => {
    setSpData(prev => ({
      ...prev,
      countryCode: code
    }));

    setCountryCodeInput('');
    setShowCountryCodeDropdown(false);
  };

  const selectWhatsAppCode = (code) => {
    setSpData(prev => ({
      ...prev,
      whatsappCode: code
    }));

    setWhatsappCodeInput('');
    setShowWhatsAppCodeDropdown(false);
  };

  const handleWhatsappChange = (e) => {
    setSpData(prev => ({
      ...prev,
      whatsappNumber: e.target.value
    }));
  };

  const addCountry = (countryName) => {
    if (!spData.countries.includes(countryName)) {
      setSpData({
        ...spData,
        countries: [...spData.countries, countryName]
      });
    }

    setCountryInput('');
    setShowCountryDropdown(false);
  };

  const removeCountry = (countryName) => {
    setSpData({
      ...spData,
      countries: spData.countries.filter(c => c !== countryName)
    });
  };

  const addService = (service) => {
    if (service === 'Others') {
      setShowCustomServiceInput(true);
      setServiceInput('');
      setShowServiceDropdown(false);
      return;
    }

    if (!spData.services.includes(service)) {
      setSpData({
        ...spData,
        services: [...spData.services, service]
      });
    }

    setServiceInput('');
    setShowServiceDropdown(false);
  };

  const addCustomService = () => {
    const customService = spData.customService.trim();

    if (
      customService &&
      !spData.services.includes(customService)
    ) {
      setSpData({
        ...spData,
        services: [...spData.services, customService],
        customService: ''
      });
    }

    setShowCustomServiceInput(false);
  };

  const removeService = (service) => {
    setSpData({
      ...spData,
      services: spData.services.filter(s => s !== service)
    });
  };

  const addPort = (port) => {
    if (port === 'Others') {
      setShowCustomPortInput(true);
      setPortInput('');
      setShowPortDropdown(false);
      return;
    }

    if (!spData.ports.includes(port)) {
      setSpData({
        ...spData,
        ports: [...spData.ports, port]
      });
    }

    setPortInput('');
    setShowPortDropdown(false);
  };

  const addCustomPort = () => {
    const customPort = spData.customPort.trim();

    if (customPort && !spData.ports.includes(customPort)) {
      setSpData({
        ...spData,
        ports: [...spData.ports, customPort],
        customPort: ''
      });
    }

    setShowCustomPortInput(false);
  };

  const removePort = (port) => {
    setSpData({
      ...spData,
      ports: spData.ports.filter(p => p !== port)
    });
  };

  const validateForm = () => {
    if (!formData.company.trim()) {
      setError('Company name is required');
      return false;
    }

    if (formData.role === 'service-provider') {
      if (spData.countries.length === 0) {
        setError('Please select at least one country of operation');
        return false;
      }

      if (spData.services.length === 0) {
        setError('Please select at least one service you provide');
        return false;
      }

      if (spData.ports.length === 0) {
        setError('Please select at least one port');
        return false;
      }

      if (!spData.phoneNumber.trim()) {
        setError('Phone number is required');
        return false;
      }
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (submittingRef.current) {
      return;
    }

    if (!token) {
      setError('Your session has expired. Please sign in again.');
      return;
    }

    if (!['owner', 'service-provider'].includes(formData.role)) {
      setError('Please select Ship Owner or Service Provider.');
      return;
    }

    if (!validateForm()) {
      return;
    }

    submittingRef.current = true;
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const formDataToSend = new FormData();

      formDataToSend.append('company', formData.company);

      formDataToSend.append(
        'phone',
        formData.role === 'service-provider'
          ? `${spData.countryCode} ${spData.phoneNumber.trim()}`
          : formData.phone.trim()
      );

      formDataToSend.append('role', formData.role);
      formDataToSend.append('location', formData.location || '');

      if (formData.role === 'service-provider') {
        formDataToSend.append(
          'countries',
          JSON.stringify(spData.countries)
        );

        formDataToSend.append(
          'services',
          JSON.stringify(spData.services)
        );

        formDataToSend.append(
          'ports',
          JSON.stringify(spData.ports)
        );

        formDataToSend.append('phoneNumber', spData.phoneNumber);
        formDataToSend.append('countryCode', spData.countryCode);
        formDataToSend.append(
          'whatsappNumber',
          spData.whatsappNumber
        );
        formDataToSend.append('whatsappCode', spData.whatsappCode);
        formDataToSend.append(
          'useSameAsPhone',
          spData.useSameAsPhone
        );

        if (spData.companyDescription) {
          formDataToSend.append(
            'companyDescription',
            spData.companyDescription
          );
        }
      }

      const result = await completeProfile(formDataToSend);

      if (!result.success) {
        throw new Error(
          result.message || 'Failed to complete profile'
        );
      }

      const savedRole = result.user.role;

      setSuccess('Profile completed successfully! Redirecting...');

      redirectTimerRef.current = setTimeout(() => {
        navigate(`/${savedRole}/dashboard`, {
          replace: true
        });
      }, 1500);
    } catch (err) {
      setError(err.message || 'Network error. Please try again.');
      submittingRef.current = false;
      setLoading(false);
    }
  };

  const displayName = userData?.name || 'User';
  const displayEmail = userData?.email || '';

  const filteredCountries = countriesList.filter(
    c =>
      c.name.toLowerCase().includes(countryInput.toLowerCase()) &&
      !spData.countries.includes(c.name)
  );

  const filteredServices = serviceCategoriesList.filter(
    s =>
      s.toLowerCase().includes(serviceInput.toLowerCase()) &&
      !spData.services.includes(s) &&
      s !== 'Others'
  );

  const filteredCountryCodes = countryCodesList.filter(
    cc =>
      cc.country
        .toLowerCase()
        .includes(countryCodeInput.toLowerCase()) ||
      cc.code.includes(countryCodeInput)
  );

  const filteredWhatsAppCodes = countryCodesList.filter(
    cc =>
      cc.country
        .toLowerCase()
        .includes(whatsappCodeInput.toLowerCase()) ||
      cc.code.includes(whatsappCodeInput)
  );

  const filteredPorts = portsList.filter(
    port =>
      port.toLowerCase().includes(portInput.toLowerCase()) &&
      !spData.ports.includes(port)
  );

  return (
    <div className="cp-container">
      <div className="cp-card">
        <div className="cp-header">
          <div className="cp-avatar-wrapper">
            {userData?.avatar ? (
              <img
                src={userData.avatar}
                alt="Profile"
                className="cp-avatar"
              />
            ) : (
              <div className="cp-avatar-fallback">
                {displayName.charAt(0).toUpperCase() || 'U'}
              </div>
            )}
          </div>

          <div className="cp-header-text">
            <h1>Welcome, {displayName}</h1>
            <p>{displayEmail}</p>
            <span className="cp-header-badge">
              Complete your profile
            </span>
          </div>
        </div>

        {error && (
          <div className="cp-error">
            <i className="fas fa-exclamation-circle" /> {error}
          </div>
        )}

        {success && (
          <div className="cp-success">
            <i className="fas fa-check-circle" /> {success}
          </div>
        )}

        <form onSubmit={handleSubmit} className="cp-form">
          <div className="cp-field">
            <label>I am a</label>
            <select
              name="role"
              value={formData.role}
              onChange={handleChange}
            >
              <option value="owner">Ship Owner</option>
              <option value="service-provider">
                Service Provider
              </option>
            </select>
          </div>

          <div className="cp-field">
            <label>Company Name *</label>
            <input
              type="text"
              name="company"
              value={formData.company}
              onChange={handleChange}
              placeholder="Enter your company name"
            />
          </div>

          {formData.role === 'owner' && (
            <div className="cp-field">
              <label>Phone Number</label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="+971 XX XXX XXXX"
              />
            </div>
          )}

          <div className="cp-field">
            <label>Location</label>
            <input
              type="text"
              name="location"
              value={formData.location}
              onChange={handleChange}
              placeholder="City, Country"
            />
          </div>

          {formData.role === 'service-provider' && (
            <>
              <div className="cp-section-divider">
                <span>Service Provider Details</span>
              </div>

              <div className="cp-field" ref={countryDropdownRef}>
                <label>Countries of Operation *</label>

                <div className="cp-tags-container">
                  {spData.countries.map(country => (
                    <span key={country} className="cp-tag">
                      {country}{' '}
                      <i
                        className="fas fa-times"
                        onClick={() => removeCountry(country)}
                      />
                    </span>
                  ))}

                  <input
                    type="text"
                    placeholder="Search and add country..."
                    value={countryInput}
                    onFocus={() => setShowCountryDropdown(true)}
                    onChange={e => setCountryInput(e.target.value)}
                    className="cp-tags-input"
                  />
                </div>

                {showCountryDropdown &&
                  filteredCountries.length > 0 && (
                    <div className="cp-dropdown">
                      {filteredCountries.map(c => (
                        <div
                          key={c.name}
                          onClick={() => addCountry(c.name)}
                        >
                          {c.flag} {c.name}
                        </div>
                      ))}
                    </div>
                  )}

                <small>
                  Select all countries where you provide services
                </small>
              </div>

              <div className="cp-field" ref={portDropdownRef}>
                <label>Ports of Operation *</label>

                <div className="cp-tags-container">
                  {spData.ports.map(port => (
                    <span key={port} className="cp-tag">
                      {port}{' '}
                      <i
                        className="fas fa-times"
                        onClick={() => removePort(port)}
                      />
                    </span>
                  ))}

                  <input
                    type="text"
                    placeholder="Search and add port..."
                    value={portInput}
                    onFocus={() => setShowPortDropdown(true)}
                    onChange={e => setPortInput(e.target.value)}
                    className="cp-tags-input"
                  />
                </div>

                {showPortDropdown && (
                  <div className="cp-dropdown">
                    {filteredPorts.map(port => (
                      <div
                        key={port}
                        onClick={() => addPort(port)}
                      >
                        <i className="fas fa-check-circle" />{' '}
                        {port}
                      </div>
                    ))}

                    <div
                      onClick={() => addPort('Others')}
                      className="cp-dropdown-add"
                    >
                      <i className="fas fa-plus-circle" />{' '}
                      Others (Add Custom Port)
                    </div>
                  </div>
                )}

                {showCustomPortInput && (
                  <div className="cp-custom-input">
                    <input
                      type="text"
                      placeholder="Enter custom port name..."
                      value={spData.customPort}
                      onChange={e =>
                        setSpData(prev => ({
                          ...prev,
                          customPort: e.target.value
                        }))
                      }
                      autoFocus
                    />

                    <button
                      type="button"
                      onClick={addCustomPort}
                    >
                      Add
                    </button>

                    <button
                      type="button"
                      onClick={() => setShowCustomPortInput(false)}
                      className="cp-cancel"
                    >
                      Cancel
                    </button>
                  </div>
                )}

                <small>Select all ports where you operate</small>
              </div>

              <div className="cp-field" ref={serviceDropdownRef}>
                <label>Services You Provide *</label>

                <div className="cp-tags-container">
                  {spData.services.map(service => (
                    <span
                      key={service}
                      className="cp-tag cp-tag-service"
                    >
                      <i className="fas fa-wrench" /> {service}{' '}
                      <i
                        className="fas fa-times"
                        onClick={() => removeService(service)}
                      />
                    </span>
                  ))}

                  <input
                    type="text"
                    placeholder="Search and add service..."
                    value={serviceInput}
                    onFocus={() => setShowServiceDropdown(true)}
                    onChange={e => setServiceInput(e.target.value)}
                    className="cp-tags-input"
                  />
                </div>

                {showServiceDropdown && (
                  <div className="cp-dropdown">
                    {filteredServices.map(s => (
                      <div
                        key={s}
                        onClick={() => addService(s)}
                      >
                        <i className="fas fa-check-circle" /> {s}
                      </div>
                    ))}

                    <div
                      onClick={() => addService('Others')}
                      className="cp-dropdown-add"
                    >
                      <i className="fas fa-plus-circle" />{' '}
                      Others (Add Custom Service)
                    </div>
                  </div>
                )}

                {showCustomServiceInput && (
                  <div className="cp-custom-input">
                    <input
                      type="text"
                      placeholder="Enter custom service name..."
                      value={spData.customService}
                      onChange={e =>
                        setSpData(prev => ({
                          ...prev,
                          customService: e.target.value
                        }))
                      }
                      autoFocus
                    />

                    <button
                      type="button"
                      onClick={addCustomService}
                    >
                      Add
                    </button>

                    <button
                      type="button"
                      onClick={() =>
                        setShowCustomServiceInput(false)
                      }
                      className="cp-cancel"
                    >
                      Cancel
                    </button>
                  </div>
                )}

                <small>
                  Select all maritime services your company offers
                </small>
              </div>

              <div className="cp-field">
                <label>Phone Number (with country code) *</label>

                <div className="cp-phone-group">
                  <div
                    className="cp-code-selector"
                    ref={countryCodeRef}
                  >
                    <button
                      type="button"
                      onClick={() =>
                        setShowCountryCodeDropdown(
                          !showCountryCodeDropdown
                        )
                      }
                      className="cp-code-btn"
                    >
                      <span>{spData.countryCode}</span>
                      <i className="fas fa-chevron-down" />
                    </button>

                    {showCountryCodeDropdown && (
                      <div className="cp-code-dropdown">
                        <div className="cp-code-search">
                          <input
                            type="text"
                            placeholder="Search country or code..."
                            value={countryCodeInput}
                            onChange={e =>
                              setCountryCodeInput(e.target.value)
                            }
                            autoFocus
                          />
                        </div>

                        {filteredCountryCodes.map(cc => (
                          <div
                            key={`${cc.country}-${cc.code}`}
                            onClick={() =>
                              selectCountryCode(cc.code)
                            }
                          >
                            <span>{cc.flag}</span>{' '}
                            <span>{cc.code}</span>{' '}
                            <span className="cp-code-country">
                              {cc.country}
                            </span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  <input
                    type="tel"
                    name="phoneNumber"
                    placeholder="Phone number"
                    value={spData.phoneNumber}
                    onChange={handleSpChange}
                    className="cp-phone-input"
                  />
                </div>
              </div>

              <div className="cp-field">
                <div className="cp-whatsapp-header">
                  <label>WhatsApp Number</label>

                  <label className="cp-same-phone">
                    <input
                      type="checkbox"
                      checked={spData.useSameAsPhone}
                      onChange={e =>
                        handleUseSameAsPhone(e.target.checked)
                      }
                    />
                    <span>Same as phone</span>
                  </label>
                </div>

                <div className="cp-phone-group">
                  <div
                    className="cp-code-selector"
                    ref={whatsappCodeRef}
                  >
                    <button
                      type="button"
                      onClick={() =>
                        setShowWhatsAppCodeDropdown(
                          !showWhatsAppCodeDropdown
                        )
                      }
                      className="cp-code-btn"
                    >
                      <span>{spData.whatsappCode}</span>
                      <i className="fas fa-chevron-down" />
                    </button>

                    {showWhatsAppCodeDropdown && (
                      <div className="cp-code-dropdown">
                        <div className="cp-code-search">
                          <input
                            type="text"
                            placeholder="Search country or code..."
                            value={whatsappCodeInput}
                            onChange={e =>
                              setWhatsappCodeInput(e.target.value)
                            }
                            autoFocus
                          />
                        </div>

                        {filteredWhatsAppCodes.map(cc => (
                          <div
                            key={`${cc.country}-${cc.code}`}
                            onClick={() =>
                              selectWhatsAppCode(cc.code)
                            }
                          >
                            <span>{cc.flag}</span>{' '}
                            <span>{cc.code}</span>{' '}
                            <span className="cp-code-country">
                              {cc.country}
                            </span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  <input
                    type="tel"
                    name="whatsappNumber"
                    placeholder="WhatsApp number"
                    value={spData.whatsappNumber}
                    onChange={handleWhatsappChange}
                    readOnly={spData.useSameAsPhone}
                    className="cp-phone-input"
                    style={
                      spData.useSameAsPhone
                        ? {
                            opacity: 0.7,
                            borderColor: 'var(--primary)'
                          }
                        : {}
                    }
                  />
                </div>

                {spData.useSameAsPhone && (
                  <div className="cp-same-phone-note">
                    <i className="fas fa-info-circle" />{' '}
                    WhatsApp number will be same as phone number
                  </div>
                )}
              </div>

              <div className="cp-field">
                <label>Company Description (Optional)</label>

                <textarea
                  name="companyDescription"
                  rows="4"
                  placeholder="Tell us about your company, services, certifications, and experience..."
                  value={spData.companyDescription}
                  onChange={handleSpChange}
                />
              </div>
            </>
          )}

          <div className="cp-submit">
            <button
              type="submit"
              className="cp-btn-primary"
              disabled={loading}
            >
              {loading ? 'Saving...' : 'Complete Profile'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CompleteProfile;